export default "__VITE_ASSET__Cxb2B3tr__"